import React from 'react';
import { Card, Flex, Grid, Text, ThemeProvider } from 'theme-ui';

import { NavLink } from '../../../../components';
import { STRINGS } from '../../../../constants';
import theme from '../../../../theme';
import styles from './SettingsMenuScreen.style';

const SettingsMenuScreen = (props) => {
  const { children } = props;

  const renderMenuElement = (url, text) => {
    return (
      <NavLink label={text} key={url} path={url} sx={styles.navLink}>
        <Flex sx={styles.navLink.container}>
          <Text sx={styles.navLink.valueText}>{text}</Text>
        </Flex>
      </NavLink>
    );
  };

  const renderSettingsMenuPanel = () => {
    return (
      <Card variant="settingsCard" sx={styles.card}>
        <Flex sx={styles.menu} as="nav">
          {renderMenuElement('/settings/profile', STRINGS.settings.profile)}
          {renderMenuElement('/settings/subscription', STRINGS.settings.subscription)}
          {renderMenuElement('/settings/help-desk', STRINGS.settings.createTicket)}
          {renderMenuElement('/settings/terms', STRINGS.settings.termsTitle)}
        </Flex>
      </Card>
    );
  };

  return (
    <Grid sx={styles.grid}>
      {renderSettingsMenuPanel()}
      <Flex sx={styles.childrenContainer}>{children}</Flex>
    </Grid>
  );
};

export default SettingsMenuScreen;
